import { HttpClient } from "src/library/HttpClient";
import { apiConfig } from "src/config/apiConfig";

export default class CertificateAppealService {
  async GetId(certificateGuid: String): Promise<any> {
    return HttpClient.getDefaultClient().get(
      apiConfig.prefixes.certificateAppeal +
        "get-certificate?qrCode=" +
        certificateGuid
    );
  }
}
